module.exports = __webpack_public_path__ + "static/media/4_paket_frei.a419327b.png";